import ListboxInput from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/listbox_input/listbox_input.vue?vue3';
export default {
    name: 'NotificationEmailListboxInput',
    components: {
        ListboxInput
    },
    inject: [
        'label',
        'name',
        'emails',
        'emptyValueText',
        'value',
        'disabled',
        'placement'
    ],
    data () {
        return {
            selected: this.value
        };
    },
    computed: {
        options () {
            return [
                {
                    value: '',
                    text: this.emptyValueText
                },
                ...this.emails.map((email)=>({
                        text: email,
                        value: email
                    }))
            ];
        }
    },
    methods: {
        async onSelect () {
            await this.$nextTick();
            this.$el.closest('form').submit();
        }
    }
};
